// extracted by mini-css-extract-plugin
export default {"cls1":"uqC7MwtUvwrM2qRgKwq4","cls2":"h_MGeXSEn7he8sHr6ar0 uqC7MwtUvwrM2qRgKwq4"};